module.exports = __webpack_public_path__ + "static/media/headphone.f052effa.svg";